import Auth from '@api/Auth'
import LoadingPage from '@components/loading/LoadingPage'
import PageLayout from '@components/page/PageLayout'
import TextParameter from '@components/text/TextParameter'
import { Flex, Paper, Text } from '@mantine/core'
import React from 'react'

const AdminHome = () => {
    const profile = Auth.useGetProfile()

    if (profile.isLoading && !profile.data) {
        return <LoadingPage />
    }

    enum Role {
        'SUPER ADMIN' = 1,
        'ADMIN',
        'STAFF',
    }

    const auth = profile.data
    return (
        <PageLayout pageTitle='ยินดีต้อนรับเข้าสู่ระบบ'>
            <Paper p='lg' shadow='lg'>
                <Flex gap='xs' direction='column'>
                    <Text fw='bold' c='text.2'>
                        ข้อมูลผู้ใช้งาน
                    </Text>
                    <TextParameter
                        title='ชื่อ-สกุล'
                        info={`คุณ ${auth?.first_name!} ${auth?.last_name!}`}
                    />
                    <TextParameter
                        title='ชื่อผู้ใช้งาน'
                        info={auth?.username!}
                    />
                    <TextParameter
                        title='สิทธิการใช้งาน'
                        info={Role[auth?.role_id || 3]}
                    />
                </Flex>
            </Paper>
        </PageLayout>
    )
}

export default AdminHome
